import type { Organization } from './organization'
import type { Feature } from './user'

export interface Role {
  id: string
  name: string
  global: boolean
  inheritable: boolean
  permissions: string[]
  rootOrganizationId: string
  rank: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface RoleDTO {
  name: string
  global: boolean
  inheritable: boolean
  permissions: string[]
}

export interface UserRole {
  userId: string
  organization: Organization
  role: Role
  organizationFeatures: Feature[]
}

export interface OrganizationRolePair {
  roleId: string
  organizationId: string
}

export const lookupMemberRole = (roles: Role[]): Role | null => {
  const role = roles.find((role) => role.name === 'Member')
  if (role) {
    return role
  }
  return null
}

export const lookupGuestRole = (roles: Role[]): Role | null => {
  const role = roles.find((role) => role.name === 'Guest')
  if (role) {
    return role
  }
  return null
}

export const lookupOwnerRole = (roles: Role[]): Role | null => {
  const role = roles.find((role) => role.name === 'Owner')
  if (role) {
    return role
  }
  return null
}
